module.exports = __webpack_public_path__ + "img/gl.95d0fbf5.png";